import styled from "styled-components";

export const SuggestionChip = styled.div`
  ${(props) => props?.theme?.themeConfig?.chatMessages?.suggestionShips?.chip?.styles};

  & {
    border: 1px solid transparent;
    transition: 0.3s;
  }
  
  &:hover {
    border-color: ${(props) => props?.theme?.themeConfig?.chatMessages?.suggestionShips?.chip?.styles.color};
  }
`